import axios from 'axios';

import { simpleProjectServiceUrl } from '../../config/environment';

export const getUserProfile = async (): Promise<SimpleProjectServiceAPI.UserDto | Error> => {
  const response = await axios.get(`${simpleProjectServiceUrl}/api/v1/user-profile`);

  if (response instanceof Error) {
    return new Error(response.message);
  }

  return response.data;
};
